import { connect } from 'react-redux'

import { setActiveProperty, toggleWishlist } from '../redux/modules/search/actions'

import ImageMultiFormGrid from '../components/ImageMultiFormGrid'

const mapStateToProps = (state) => ({
  results: state.search.results,
  pricesForBookedAccommodations: state.search.prices_for_booked_accommodations,
  bookingIdsForBookedAccommodations: state.search.booking_ids_for_booked_accommodations,
  wishlistOrderAccIdsForBookedAccommodations: state.search.wishlist_order_accommodation_ids_for_booked_accommodations

})

const actionCreators = { setActiveProperty, toggleWishlist }

export default connect(mapStateToProps, actionCreators)(ImageMultiFormGrid)



// WEBPACK FOOTER //
// ./src/containers/ImageMultiFormGrid.js